import { useParams } from "react-router-dom";
import { Seo } from "../components/Seo";
import { Reveal, SectionHeading } from "../components/Reveal";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Vrova (vrova.in) respects your privacy. This policy explains what we collect and why.",
      "Information you provide: when you submit an enquiry, partnership form or newsletter signup, we collect the details you share — such as your name, email, phone number, company and message — solely to respond to your request and operate our business.",
      "Cookies: we use essential cookies for site functionality and, with your consent, optional analytics and marketing cookies. You can change your choice at any time via the cookie preferences banner.",
      "We do not sell your personal information. Enquiry data is stored securely and accessed only by the Vrova team.",
      "To access, correct or delete your data, contact us on WhatsApp at +91 62811 28057 or via the contact page.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      "By using vrova.in you agree to these terms.",
      "Content on this site, including experience listings, is for general information. Some experiences shown are showcase/demonstration listings and availability may vary by location and date.",
      "VR/XR experiences carry age, health and safety guidelines which are communicated at each venue and must be followed by all participants.",
      "All trademarks, text and design on this site belong to Vrova unless otherwise stated. Do not reproduce without permission.",
      "These terms are governed by the laws of India, with jurisdiction in Hyderabad, Telangana.",
    ],
  },
  cookies: {
    title: "Cookie Policy",
    body: [
      "This site uses a small number of cookies.",
      "Essential cookies: required for the site and forms to function. These cannot be disabled.",
      "Analytics cookies (optional): help us understand how visitors use the site so we can improve it. Enabled only with your consent.",
      "Marketing cookies (optional): used to measure campaigns and show relevant updates. Enabled only with your consent.",
      "You can accept all cookies, reject non-essential cookies, or manage preferences at any time via the consent banner.",
    ],
  },
};

export default function Legal() {
  const { page } = useParams();
  const doc = CONTENT[page] || CONTENT.privacy;
  return (
    <main className="pt-40 pb-28">
      <Seo title={doc.title} path={`/legal/${page}`} description={`Vrova ${doc.title}`} />
      <div className="max-w-3xl mx-auto px-6">
        <SectionHeading overline="Legal" title={doc.title} />
        <Reveal delay={0.15} className="mt-12 space-y-6" data-testid="legal-content">
          {doc.body.map((p) => (
            <p key={p.slice(0, 60)} className="text-zinc-400 font-light leading-relaxed">{p}</p>
          ))}
        </Reveal>
      </div>
    </main>
  );
}
